import { Box, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function RunSummaryAgentList({ items = [] }) {
  if (!items.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No details available.
      </Typography>
    );
  }

  return (
    <Box component="ul" sx={runSummaryAgentReportStyles.list}>
      {items.map((item) => (
        <Typography
          key={item}
          component="li"
          variant="body2"
          sx={runSummaryAgentReportStyles.listItem}
        >
          {item}
        </Typography>
      ))}
    </Box>
  );
}
